import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink';
import { NarrativeImpactReportService, NarrativeImpactReport } from '../../../../services/narrative-impact-report.service';
import { CentreService } from '../../../../services/centre.service';
import { Centre } from '../../../../interfaces/Centres';

@Component({
  selector: 'app-narrative-impact-report-table',
  templateUrl: './narrative-impact-report-table.component.html',
  styleUrls: ['./narrative-impact-report-table.component.scss'],
})
export class NarrativeImpactReportTableComponent implements OnInit, OnDestroy {
  centres$: Observable<Centre[]>;
  reports: NarrativeImpactReport[] = [];
  selectedCentre = '';
  loading = false;

  displayedColumns = ['centreName', 'quarterLabel', 'periodLabel', 'submitType', 'createdAt', 'actions'];

  private subs = new SubSink();

  constructor(
    private reportService: NarrativeImpactReportService,
    private centreService: CentreService,
    private router: Router,
  ) {
    this.centres$ = this.centreService.getAllCentres();
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  loadReports(): void {
    if (!this.selectedCentre) return;
    this.loading = true;
    this.subs.add(
      this.reportService.getReports(this.selectedCentre).subscribe(reports => {
        this.reports = reports;
        this.loading = false;
      })
    );
  }

  createNew(): void {
    this.router.navigate(['reports/narrative-impact-report']);
  }
}
